module.exports = __webpack_public_path__ + "img/update.adce52ec.svg";